import React, { useState } from 'react';
import { X, ChevronDown, ChevronUp } from 'lucide-react';
import { ProductInfo } from '../services/productCatalog';

interface SensorHintCardProps {
  product: ProductInfo;
  onDismiss: (type: string) => void;
}

const ACCENT_ICON_CLASS: Record<string, string> = {
  cyan: 'text-cyan-500/70',
  blue: 'text-blue-500/70',
  orange: 'text-orange-500/70',
  yellow: 'text-yellow-500/70',
  emerald: 'text-emerald-500/70',
};

const SensorHintCard: React.FC<SensorHintCardProps> = ({ product, onDismiss }) => {
  const [expanded, setExpanded] = useState(false);
  const Icon = product.icon;
  const iconClass = ACCENT_ICON_CLASS[product.accent] ?? 'text-slate-500';

  return (
    <div className="bg-slate-800/30 rounded-xl border border-dashed border-slate-700/60 overflow-hidden">
      <div className="px-4 py-3 flex items-center gap-3">
        <div className="p-2 bg-slate-900/50 rounded-lg shrink-0">
          <Icon className={`w-5 h-5 ${iconClass}`} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="font-medium text-slate-400 text-sm">{product.name}</h3>
            <span className="text-[10px] font-semibold text-slate-600 uppercase tracking-wide">Not added</span>
          </div>
          <p className="text-xs text-slate-500 truncate">{product.pitch}</p>
        </div>
        <button
          onClick={() => setExpanded(e => !e)}
          className="p-1.5 text-slate-600 hover:text-slate-400 transition-colors shrink-0"
          aria-label={expanded ? 'Show less' : 'Learn more'}
        >
          {expanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
        </button>
        <button
          onClick={() => onDismiss(product.type)}
          className="p-1.5 text-slate-600 hover:text-slate-400 transition-colors shrink-0"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      {expanded && (
        <div className="px-4 pb-3">
          <p className="text-xs text-slate-500 leading-relaxed border-t border-slate-700/40 pt-3">
            {product.detail}
          </p>
        </div>
      )}
    </div>
  );
};

export default SensorHintCard;
